import { useApp } from "../../hooks";
import { SVGs } from "../../assets";
import Icon from "../icon";
import Text from "../text";
import React from "react";

const Copyable = ({ level = "text", children = "" }) => {
  const { message } = useApp();
  return (
    <Text
      level={level}
      type="secondary"
      className="cursor-pointer m-10-l"
      children={<Icon component={SVGs.copyComp} />}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(children);
          message.success({ content: "Copied!" });
        } catch (error) {
          message.error({ content: "Copying failed!" });
        }
      }}
    />
  );
};

export default Copyable;
